import { createRouter, createWebHashHistory } from 'vue-router';
import store from '../store/index'; // Vuex Store

import HomeView from '../views/HomeView.vue';
import AboutView from '../views/AboutView.vue';
import ServicesView from '../views/ServicesView.vue';
import ContactView from '../views/ContactView.vue';
import LoginView from '../views/LoginView.vue';
import DashboardPage from '../views/DashboardPage.vue';
import CounselorsIndex from '@/views/counselors/CounselorsIndex.vue';
import CounselorsForm from '@/views/counselors/CounselorsForm.vue';
import EmployeeIndex from '@/views/employees/EmployeeIndex.vue';
import EmployeeForm from '@/views/employees/EmployeeForm.vue';
import StudentsIndex from '@/views/students/StudentsIndex.vue';
import StudentForm from '@/views/students/StudentForm.vue';
import DaysIndex from '@/views/days/DaysIndex.vue';
import DepartmentAdd from '@/views/department/DepartmentAdd.vue';
import DaysForm from '@/views/days/DaysForm.vue';
import TimeSlotIndex from '@/views/timeslots/TimeSlotIndex.vue';
import TimeSlotForm from '@/views/timeslots/TimeSlotForm.vue';

import GroupsIndex from '@/views/groups/GroupsIndex.vue';
import GroupForm from '@/views/groups/GroupForm.vue';

import AgendaIndex from '@/views/agenda/AgendaIndex.vue';
import AgendaForm from '@/views/agenda/AgendaForm.vue';

import AssignStudentsToGroup from '@/views/groups/AssignStudentsToGroup.vue';
import ViewAssignedStudents from '@/views/groups/ViewAssignedStudents.vue';

import TimeTableIndex from '@/views/timetable/TimeTableIndex.vue';

import StudentAttendance from '@/views/attendance/StudentAttendance.vue';
import ViewAttendance from '@/views/attendance/ViewAttendance.vue';

import FrontDeskForm from '@/views/frontdesk/FrontDeskForm.vue';
import FrontDeskIndex from '@/views/frontdesk/FrontDeskIndex.vue';

import AppointmentIndex from '@/views/appointment/AppointmentIndex.vue';
import AppointmentForm from '@/views/appointment/AppointmentForm.vue';

import AttendanceDashboard from '@/views/attendance/AttendanceDashboard.vue';

// import DocumentsIndex from '@/views/DocumentsIndex.vue';

import DoctorOrderStudentDetail from '@/views/doctororder/DoctorOrderStudentDetail.vue';
import DoctorOrderForm from '@/views/doctororder/DoctorOrderForm.vue';
import NurseForm from '@/views/nurses/NurseForm.vue';
import NurseList from '@/views/nurses/NurseList.vue';
import MedicationList from '@/views/medications/MedicationList.vue';
import MedicationForm from '@/views/medications/MedicationForm.vue';
import NurseSchedule from "@/views/nurses/NurseSchedule.vue";

import PhaseScheduleList from '@/views/phase_schedule/PhaseScheduleList.vue';
import PhaseScheduleForm from '@/views/phase_schedule/PhaseScheduleForm.vue';
import PhaseDeterminationList from '@/views/phase_determinations/PhaseDeterminationList.vue';
import PhaseDeterminationForm from '@/views/phase_determinations/PhaseDeterminationForm.vue';
import StaffingRequirementList from '@/views/staffing_requirements/StaffingRequirementList.vue';
import StaffingRequirementAdd from '@/views/staffing_requirements/StaffingRequirementAdd.vue';
import StaffingRequirementView from '@/views/staffing_requirements/StaffingRequirementView.vue';
import PhaseDeterminationDetail from '@/views/phase_determinations/PhaseDeterminationDetail.vue';
import TakeHomeCriteriaForm from '@/views/take_home_criteria/TakeHomeCriteriaForm.vue';
import NursingReviewForm from '@/views/nursing_review/NursingReviewForm.vue';
import PhysicianReviewForm from '@/views/phase_determinations/PhysicianReviewForm.vue';
import PhysicianDeterminationForm from '@/views/phase_determinations/PhysicianDeterminationForm.vue';
import IOPmedicalPrintDetail from '@/views/iop_medical_print_file/IOPmedicalPrintDetail.vue';
import IOPMecicalDemographicForm from '@/views/iop_medical_print_file/IOPMecicalDemographicForm.vue';
import IOPMedicalHistoryForm from '@/views/iop_medical_print_file/IOPMedicalHistoryForm.vue';
import IOPMedicalTest from '@/views/iop_medical_print_file/IOPMedicalTest.vue';
import IOPMedicalVitals from '@/views/iop_medical_print_file/IOPMedicalVital.vue';
import IOPObstetricalHistoryForm from '@/views/iop_medical_print_file/IOPObstetricalHistoryForm.vue';

import TestFile from '@/views/TestFile.vue';

import DepartmentsList from '@/views/department/DepartmentList.vue';
import ShiftList from '@/views/shifts/ShiftList.vue';
import ShiftAdd from '@/views/shifts/ShiftAdd.vue';
// import ShiftAssignmentAdd from '@/views/shifts/ShiftAssignmentAdd.vue';
import ReasonList from '@/views/reasons/ReasonList.vue';
import ReasonForm from '@/views/reasons/ReasonForm.vue';

import PractitionerList from '@/views/practitioner/PractitionerList.vue';
import PractitionerForm from '@/views/practitioner/PractitionerForm.vue';


import DoctorOrderList from '@/views/doctororder/DoctorOrderList.vue';
import PractitionerSignature from '@/views/doctororder/PractitionerSignature.vue';
import SpecializationList from '@/views/specialization/SpecializationList.vue';
import SpecializationForm from '@/views/specialization/SpecializationAdd.vue';

import PractitionerSignaturePhaseDetermination from '@/views/phase_determinations/PractitionerSignaturePhaseDetermination.vue';
import ShiftView from '@/views/shifts/ShiftView.vue';

import PatientActivityLevelAdd from '@/views/activity_level/PatientActivityLevelAdd.vue';
import PatientActivityLevelList from '@/views/activity_level/PatientActivityLevelList.vue';
import PatientActivityLevelEdit from '@/views/activity_level/PatientActivityLevelEdit.vue';
import PatientActivityLevelView from '@/views/activity_level/PatientActivityLevelView.vue';
// import DocumentsIndex from '@/views/DocumentsIndex.vue';

import DocumentsIndex from '@/views/DocumentsIndex.vue';


const routes = [
  { path: '/test', component: TestFile },
  { path: '/', name: 'Home', component: HomeView },
  { path: '/about', name: 'About', component: AboutView },
  { path: '/services', name: 'Services', component: ServicesView },
  { path: '/contact', name: 'Contact', component: ContactView },
  { path: '/login', name: 'Login', component: LoginView },
  { path: '/dashboard', name: 'Dashboard', component: DashboardPage, meta: { requiresAuth: true } },

  {
    path: '/dashboard',
    component: DashboardPage,
    children: [
      {
        path: 'counselors',
        name: 'CounselorsIndex',
        component: CounselorsIndex,

      },
      {
        path: 'counselors/add',
        name: 'CounselorsAdd',
        component: CounselorsForm,

      },
      {
        path: 'counselors/edit/:id',
        name: 'CounselorsEdit',
        component: CounselorsForm,

      },
      {
        path: 'employees',
        name: 'EmployeeIndex',
        component: EmployeeIndex,

      },
      {
        path: 'employees/add',
        name: 'EmployeeCreate',
        component: EmployeeForm,

      },
      {
        path: 'employees/edit/:id',
        name: 'EmployeeEdit',
        component: EmployeeForm,
        props: true,

      },
      {
        path: 'clients',
        name: 'StudentsIndex',
        component: StudentsIndex,

      },
      {
        path: 'clients/add',
        name: 'StudentCreate',
        component: StudentForm,

      },
      {
        path: 'clients/edit/:id',
        name: 'StudentEdit',
        component: StudentForm,
        props: true,

      },
      {
        path: 'days',
        name: 'DaysIndex',
        component: DaysIndex
      },
      {
        path: 'days/create',
        name: 'DaysCreate',
        component: DaysForm
      },
      {
        path: 'days/edit/:id',
        name: 'DaysEdit',
        component: DaysForm,
        props: true
      },
      {
        path: 'time-slots',
        name: 'TimeSlotIndex',
        component: TimeSlotIndex
      },
      {
        path: 'time-slots/create',
        name: 'TimeSlotCreate',
        component: TimeSlotForm
      },
      {
        path: 'time-slots/edit/:id',
        name: 'TimeSlotEdit',
        component: TimeSlotForm
      },
      {
        path: 'groups',
        name: 'GroupsIndex',
        component: GroupsIndex
      },
      {
        path: 'groups/add',
        name: 'GroupAdd',
        component: GroupForm
      },
      {
        path: 'groups/edit/:id',
        name: 'GroupEdit',
        component: GroupForm,
        props: true
      },
      {
        path: 'groups/assign/:id',
        name: 'AssignStudents',
        component: AssignStudentsToGroup,
        props: true
      },
      {
        path: '/dashboard/groups/view/:id',
        name: 'ViewAssignedStudents',
        component: ViewAssignedStudents,
        props: true
      },
      {
        path: 'agendas',
        name: 'AgendaIndex',
        component: AgendaIndex
      },
      {
        path: 'agendas/create',
        name: 'AgendaCreate',
        component: AgendaForm
      },
      {
        path: 'agendas/:id/edit',
        name: 'AgendaEdit',
        component: AgendaForm,
        props: true
      },
      {
        path: 'timetable-index',
        component: TimeTableIndex,
        name: 'TimeTableIndex'
      },
      {
        path: 'attendance',
        component: StudentAttendance,
        name: 'StudentAttendance'
      },
      {
        path: 'attendance/view',
        component: ViewAttendance,
        name: 'ViewAttendance',
      },
      {
        path: 'frontdesk',
        component: FrontDeskIndex,
        name: 'FrontDeskIndex',

      },
      {
        path: 'frontdesk/create',
        component: FrontDeskForm,

      },
      {
        path: 'frontdesk/edit/:id',
        component: FrontDeskForm,
        props: true,

      },
      {
        path: 'appointments',
        component: AppointmentIndex,
        name: 'AppointmentIndex',

      },
      {
        path: 'appointments/create',
        component: AppointmentForm,

      },
      {
        path: 'appointments/edit/:id',
        component: AppointmentForm,
        props: true,

      },
      {
        path: 'attendance_dashboard',
        component: AttendanceDashboard,
        name: 'AttendanceDashboard',

      },
      {
        path: 'documents',
        component: DocumentsIndex,
        name: 'DocumentsIndex',

      },
      // {
      //   path: '/dashboard/doctor-orders',
      //   name: 'doctor-orders',
      //   component: () => import('@/views/DoctorOrder/DoctorOrderList.vue')
      // },


      { path: 'clients/:id/doctor-orders', name: 'student-doctor-orders', component: DoctorOrderStudentDetail, props: true },
      { path: 'doctor-orders/create', name: 'doctor-order-create', component: DoctorOrderForm },
      { path: 'doctor-orders/edit/:id', name: 'doctor-order-edit', component: DoctorOrderForm, props: true },

      { path: 'nurses/add', name: 'nurse-add', component: NurseForm },
      { path: 'nurses/edit/:id', name: 'nurse-edit', component: NurseForm, props: true },
      { path: 'nurses', name: 'nurses', component: NurseList },

      { path: 'medications', name: 'medication-list', component: MedicationList },
      { path: 'medications/add', name: 'medication-add', component: MedicationForm },
      { path: 'medications/edit/:id', name: 'medication-edit', component: MedicationForm, props: true },

      { path: 'phase-schedules', name: 'PhaseScheduleList', component: PhaseScheduleList },
      { path: 'phase-schedules/add', name: 'PhaseScheduleAdd', component: PhaseScheduleForm },
      { path: 'phase-schedules/edit/:id', name: 'PhaseScheduleEdit', component: PhaseScheduleForm, props: true },

      { path: 'phase-determinations', name: 'PhaseDeterminationList', component: PhaseDeterminationList },
      { path: 'phase-determinations/add/:student_id?', name: 'PhaseDeterminationAdd', component: PhaseDeterminationForm, props: true },
      { path: 'phase-determinations/edit/:id', name: 'PhaseDeterminationEdit', component: PhaseDeterminationForm, props: true },
      { path: 'phase-determinations/student/:student_id', name: 'PhaseDeterminationDetail', component: PhaseDeterminationDetail, props: true },

      { path: 'take-home-criteria/add/:phase_determination_id', name: 'TakeHomeCriteriaAdd', component: TakeHomeCriteriaForm, props: true },
      { path: 'take-home-criteria/edit/:id', name: 'TakeHomeCriteriaEdit', component: TakeHomeCriteriaForm, props: true },

      { path: 'nursing-review/add/:phase_determination_id', name: 'AddNursingReview', component: NursingReviewForm, props: true },
      { path: 'nursing-review/edit/:id', name: 'EditNursingReview', component: NursingReviewForm, props: true },

      { path: 'physician-review/add/:phase_determination_id', name: 'PhysicianReviewAdd', component: PhysicianReviewForm },
      { path: 'physician-review/edit/:id', name: 'PhysicianReviewEdit', component: PhysicianReviewForm },

      { path: 'physician-determination/add/:phase_determination_id', name: 'PhysicianDeterminationAdd', component: PhysicianDeterminationForm },
      { path: 'physician-determination/edit/:id', name: 'PhysicianDeterminationEdit', component: PhysicianDeterminationForm },
      {
        path: 'iop-medical-print-detail/:student_id',
        name: 'IOPmedicalPrintDetail',
        component: IOPmedicalPrintDetail,
      }, {
        path: 'iop-medical-demographics/:iop_medical_print_id/edit',
        name: 'IopMedicalDemographicForm',
        component: IOPMecicalDemographicForm,
        props: true,
      },
      {
        path: 'iop-medical-histories/:iop_medical_print_id/edit',
        name: 'IopMedicalHistoryForm',
        component: IOPMedicalHistoryForm,
        props: true,

      },
      {
        path: 'iop-medical-tests/:iop_medical_print_id/edit',
        name: 'IOPMedicalTest',
        component: () => IOPMedicalTest,
        props: true,

      },
      {
        path: 'iop-vitals/:iop_medical_print_id/edit',
        name: 'IOPMedicalVitals',
        component: IOPMedicalVitals,
        props: true,

      },




      // {
      //   path: '/dashboard/home',
      //   name: 'dashboard_home',
      //   component: () => import('@/components/DashboardIcons.vue'),
      //   // props: true
      // }


      {
        path: 'iop-obstetrical-histories/:iop_medical_print_id/edit',
        name: 'IOPObstetricalHistoryForm',
        component: () => IOPObstetricalHistoryForm,
        props: true
      },

      {
        path: 'reasons',
        name: 'reason-list',
        component: ReasonList, // or whatever your component is named

      },
      {
        path: '/reasons/create',
        name: 'reason-create',
        component: () => ReasonForm,

      },
      {
        path: '/reasons/:id/edit',
        name: 'reason-edit',
        component: () => ReasonForm
      },

      {
        path: '/practitioners',
        name: 'PractitionerList',
        component: PractitionerList,
      },
      {
        path: '/practitioners/add',
        name: 'PractitionerAdd',
        component: PractitionerForm,
      },
      {
        path: '/practitioners/edit/:id',
        name: 'PractitionerEdit',
        component: PractitionerForm,
        props: true,
      },
      {
        path: '/doctor-orders-list',
        name: 'DoctorOrders',
        component: DoctorOrderList,
      }, {
        path: '/doctor-orders/:id/practitioner-signature',
        name: 'PractitionerSignature',
        component: PractitionerSignature,
        props: true,
      }
      ,
      {
        path: 'phase-determination/:id/practitioner-signature',
        name: 'PractitionerSignaturePhaseDetermination',
        component: PractitionerSignaturePhaseDetermination,
        props: true,
      },
      {
        path: 'departments',
        name: 'DepartmentsList',
        component: DepartmentsList
      },
      {
        path: 'departments/add',
        name: 'DepartmentAdd',
        component: DepartmentAdd
      },
      {
        path: 'departments/edit/:id',
        name: 'DepartmentEdit',
        component: DepartmentAdd,
        props: true
      },
      {
        path: 'specializations',
        name: 'SpecializationList',
        component: SpecializationList
      },
      {
        path: 'specializations/add',
        name: 'SpecializationAdd',
        component: SpecializationForm
      },
      {
        path: 'specializations/edit/:id',
        name: 'SpecializationEdit',
        component: SpecializationForm,
        props: true
      },
      {
        path: 'shifts',
        name: 'ShiftList',
        component: ShiftList
      },
      {
        path: 'shifts/add',
        name: 'ShiftAdd',
        component: ShiftAdd
      },
      {
        path: 'shifts/edit/:id',
        name: 'ShiftEdit',
        component: ShiftAdd,
        props: true
      },
      {
        path: 'shifts/view/:id',
        name: 'ShiftView',
        component: ShiftView,
        props: true
      },
      {
        path: 'patient-activity-levels',
        name: 'PatientActivityLevelList',
        component: PatientActivityLevelList
      },
      {
        path: 'patient-activity-levels/add',
        name: 'PatientActivityLevelAdd',
        component: PatientActivityLevelAdd
      },
      {
        path: 'patient-activity-levels/edit/:id',
        name: 'PatientActivityLevelEdit',
        component: PatientActivityLevelEdit,
        props: true
      },
      {
        path: 'patient-activity-levels/view/:id',
        name: 'PatientActivityLevelView',
        component: PatientActivityLevelView,
        props: true
      },
      {
        path: 'staffing_requirements',
        name: 'StaffingRequirementList',
        component: StaffingRequirementList
      },
      {
        path: 'staffing_requirements/add',
        name: 'StaffingRequirementAdd',
        component: StaffingRequirementAdd
      },
      {
        path: 'staffing-requirements/view/:id',
        name: 'StaffingRequirementView',
        component: StaffingRequirementView,
        props: true
      },
      {
        path: 'staffing-requirements/edit/:id',
        name: 'StaffingRequirementEdit',
        component: StaffingRequirementAdd,
        props: true
      },
      {
        path:'nurse-schedule',
        name:'NurseSchedule',
        component: NurseSchedule,
      }
    ]
  }
];

const roleBasedRoutesByName = {

  Home: ['guest'],
  About: ['guest'],
  Services: ['guest'],
  Contact: ['guest'],
  Login: ['guest'],
  Dashboard: ['admin', 'employee', 'counselor', 'student', 'front desk', 'nurse', 'practitioner'],

  // Counselors
  CounselorsIndex: ['admin'],
  CounselorsAdd: ['admin'],
  CounselorsEdit: ['admin'],

  // Employees
  EmployeeIndex: ['admin'],
  EmployeeCreate: ['admin'],
  EmployeeEdit: ['admin'],

  // Students
  StudentsIndex: ['nurse', 'admin', 'front desk', 'counselor', 'practitioner'],
  StudentCreate: ['admin'],
  StudentEdit: ['admin'],

  // Days
  DaysIndex: ['admin'],
  DaysCreate: ['admin'],
  DaysEdit: ['admin'],

  // Time Slots
  TimeSlotIndex: ['admin'],
  TimeSlotCreate: ['admin'],
  TimeSlotEdit: ['admin'],

  // Groups
  GroupsIndex: ['admin'],
  GroupAdd: ['admin'],
  GroupEdit: ['admin'],
  AssignStudents: ['admin'],
  ViewAssignedStudents: ['admin'],

  // Agenda
  AgendaIndex: ['admin'],
  AgendaCreate: ['admin'],
  AgendaEdit: ['admin'],

  // Time Table
  TimeTableIndex: ['admin'],

  // Attendance
  StudentAttendance: ['admin', 'counselor', 'front desk'],
  ViewAttendance: ['admin', 'counselor', 'front desk'],
  AttendanceDashboard: ['admin', 'counselor', 'front desk'],

  // FrontDesk
  FrontDeskIndex: ['admin'],
  FrontDeskCreate: ['admin'],
  FrontDeskEdit: ['admin'],

  // Appointments
  AppointmentIndex: ['admin'],
  AppointmentCreate: ['admin'],
  AppointmentEdit: ['admin'],

  // Doctor Orders
  'student-doctor-orders': ['admin', 'practitioner'],
  'doctor-order-create': ['admin', 'practitioner'],
  'doctor-order-edit': ['admin', 'practitioner'],

  // Nurses
  'nurse-add': ['admin'],
  'nurse-edit': ['admin'],
  'nurses': ['admin'],

  // Medications
  'medication-list': ['admin'],
  'medication-add': ['admin'],
  'medication-edit': ['admin'],

  // Phase Schedules
  PhaseScheduleList: ['admin'],
  PhaseScheduleAdd: ['admin'],
  PhaseScheduleEdit: ['admin'],

  // Phase Determinations
  PhaseDeterminationList: ['practitioner'],
  PhaseDeterminationAdd: ['admin', 'practitioner'],
  PhaseDeterminationEdit: ['admin', 'practitioner'],
  PhaseDeterminationDetail: ['admin', 'counselor', 'practitioner'],


  // Take Home Criteria
  TakeHomeCriteriaAdd: ['admin'],
  TakeHomeCriteriaEdit: ['admin'],

  // Nursing Review
  AddNursingReview: ['admin', 'nurse'],
  EditNursingReview: ['admin', 'nurse'],

  // Physician Review
  PhysicianReviewAdd: ['admin', 'nurse', 'physician'],
  PhysicianReviewEdit: ['admin', 'nurse', 'physician'],

  // Physician Determination
  PhysicianDeterminationAdd: ['admin', 'nurse', 'physician'],
  PhysicianDeterminationEdit: ['admin', 'nurse', 'physician'],

  IOPmedicalPrintDetail: ['admin', 'nurse', 'doctor'],
  IopMedicalDemographicForm: ['admin'],
  IopMedicalHistoryForm: ['admin'],
  IOPMedicalTest: ['admin'],
  IOPMedicalVitals: ['admin'],
  'reason-list': ['admin'],
  'reason-create': ['admin'],
  'reason-edit': ['admin'],
  PractitionerList: ['admin'],
  PractitionerAdd: ['admin'],
  PractitionerEdit: ['admin'],
  DoctorOrders: ['practitioner'],
  PractitionerSignature: ['practitioner'],
  PractitionerSignaturePhaseDetermination: ['practitioner'],

  DepartmentsList: ['admin'],
  DepartmentAdd: ['admin'],
  DepartmentEdit: ['admin'],

  SpecializationList: ['admin'],
  SpecializationAdd: ['admin'],
  SpecializationEdit: ['admin'],

  ShiftList: ['admin', 'front desk'],
  ShiftAdd: ['admin', 'front desk'],
  ShiftEdit: ['admin', 'front desk'],
  ShiftView: ['admin', 'front desk'],

  PatientActivityLevelList: ['admin'],
  PatientActivityLevelAdd: ['admin'],
  PatientActivityLevelEdit: ['admin'],
  PatientActivityLevelView: ['admin'],
  StaffingRequirementList: ['admin'],
  StaffingRequirementAdd: ['admin'],
  StaffingRequirementView: ['admin'],
  StaffingRequirementEdit: ['admin'],
  NurseSchedule:['admin']
};
routes.forEach(route => {
  if (route.children) {
    route.children.forEach(child => {
      const roles = roleBasedRoutesByName[child.name] || ['admin'];
      child.meta = { ...(child.meta || {}), roles };
      if (!roles.includes('guest')) {
        child.meta.requiresAuth = true;
      }
    });
  } else {
    const roles = roleBasedRoutesByName[route.name] || ['admin'];
    route.meta = { ...(route.meta || {}), roles };
    if (!roles.includes('guest')) {
      route.meta.requiresAuth = true;
    }
  }
});

const router = createRouter({
  history: createWebHashHistory(),
  routes
});
router.beforeEach(async (to, from, next) => {
  const isAuthenticated = store.getters.isAuthenticated;
  const userRole = store.getters.getUser?.role || 'guest';

  const allowedRoles = to.meta.roles || ['admin'];

  console.log('user role is  ' + userRole);

  // 1. Already logged in but trying to access login page → force to dashboard
  if (to.name === 'Login' && isAuthenticated) {
    next('/dashboard');
    return;
  }

  // 2. Guest route but user is logged in → force to dashboard
  if (allowedRoles.includes('guest') && isAuthenticated && to.path !== '/dashboard') {
    next('/dashboard');
    return;
  }


  // 3. Auth route but user not logged in → force to login
  if (!allowedRoles.includes('guest') && !isAuthenticated) {
    next('/login');
    return;
  }

  // 4. Authenticated but role not loaded yet → wait (prevent navigation)
  if (!userRole && isAuthenticated) {
    return; // do nothing → wait for role
  }

  // 5. Role mismatch → force to login
  if (userRole && !allowedRoles.includes(userRole)) {
    next('/login');
    return;
  }

  // 6. Everything okay → proceed
  next();
});


export default router;
